import { FunctionComponent } from 'react';
import AiAgentFrame from 'components/AiAgent/AiAgentFrame';
import styles from './AiAgent.module.scss';
import PrivatePage from './PrivatePage';

const AiAgent: FunctionComponent = () => {
    return (
        <PrivatePage
            pageName="/bookings"
            title="AI Agent - Cuddles"
        >
            <div className={styles.container}>
                <AiAgentFrame />
            </div>
        </PrivatePage>
    );
};

export default AiAgent;
